import React, {createContext, useContext} from 'react';
import {AgentType} from '../../../shared/agent';

const AgentFieldTypeContext = createContext<AgentType | undefined>(undefined);

export function AgentFieldTypeProvider({
  children,
  fieldType,
}: {
  children: React.ReactNode;
  fieldType: AgentType;
}) {
  return (
    <AgentFieldTypeContext.Provider value={fieldType}>
      {children}
    </AgentFieldTypeContext.Provider>
  );
}

export function useAgentFieldType() {
  const context = useContext(AgentFieldTypeContext);
  if (!context) {
    throw new Error(
      'useAgentFieldType must be used within a AgentFieldTypeProvider'
    );
  }

  return context;
}
